import { SVGProps, Ref, forwardRef } from 'react';

export const EmojiHalfsadFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M.5 8C.5 1.438 1.438.5 8 .5s7.5.938 7.5 7.5-.937 7.5-7.5 7.5S.5 14.563.5 8m6.675 4.176a.47.47 0 0 0-.143.32h-1.4c0-.501.209-.944.523-1.278.45-.48 1.126-.754 1.843-.754s1.393.274 1.843.754c.314.334.523.777.523 1.279h-1.4a.47.47 0 0 0-.143-.32c-.158-.169-.45-.313-.823-.313s-.665.144-.823.312m-1.51-7.11c-.461 0-.783.154-.988.4-.202.242-.278.56-.278.866s.076.623.278.866c.205.245.527.4.988.4.462 0 .784-.155.988-.4.202-.243.279-.56.279-.866 0-.307-.077-.624-.279-.866-.204-.246-.526-.4-.988-.4m4.666 0c-.462 0-.784.154-.988.4-.202.242-.279.56-.279.866s.077.623.279.866c.204.245.526.4.988.4s.783-.155.988-.4c.202-.243.278-.56.278-.866 0-.307-.076-.624-.278-.866-.205-.246-.527-.4-.988-.4"
                fill="currentColor"
            />
        </g>
    </svg>
));
EmojiHalfsadFilledSize16Glyph.displayName = 'EmojiHalfsadFilledSize16Glyph';
